import { render, staticRenderFns } from "./whatsappDialogFromWABA.vue?vue&type=template&id=0c7788f6"
import script from "./whatsappDialogFromWABA.vue?vue&type=script&lang=js"
export * from "./whatsappDialogFromWABA.vue?vue&type=script&lang=js"
import style0 from "./whatsappDialogFromWABA.vue?vue&type=style&index=0&id=0c7788f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports